export const defaultListPayload = {
  page: 1,
  pageSize: 15,
  filters: {},
};
